module.exports = __webpack_public_path__ + "img/pin-location.6d3f2f1e.svg";